import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from '../views/Auth';
import RedirectLogin from '../views/Auth/RedirectLogin';
import RedirectForUserAuth from '../views/Auth/RedirectForUserAuth';

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="redirect" element={<RedirectForUserAuth />} />
      <Route path="app-redirect" element={<RedirectLogin />} />
      <Route path="*" element={<Navigate replace to="/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
